import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { PmsCredentialModel } from '@shared/interfaces/pms-credential-model.interface';
import { RestChatHooksChannel } from '@shared/interfaces/rest-chat-hooks-channel';
import { RestTimerReport } from '@shared/interfaces/rest-timer-report';

@Injectable({
  providedIn: 'root',
})
export class SystemConfigService {
  private restApiService: RestapiService = inject(RestapiService);

  getSystemConfig(): Observable<PmsCredentialModel[]> {
    return this.restApiService.getData<PmsCredentialModel[]>('AdminPanel/ApiCredentials');
  }

  getChatHooksChannels(): Observable<RestChatHooksChannel[]> {
    return this.restApiService.getData<RestChatHooksChannel[]>('slack/channels');
  }

  getTimerReport(): Observable<RestTimerReport[]> {
    return this.restApiService.getData<RestTimerReport[]>('Turnovers/mismatchissues');
  }

  setPropertyChatChannel(propertyId: number, channelIds: string[]): Observable<{}> {
    return this.restApiService.update<{}>(`properties/${propertyId}/UpdateSlackChannelId`, {
      channelIds,
    });
  }

  addSystemConfig(pmsCredential: PmsCredentialModel): Observable<boolean> {
    return this.restApiService.create<boolean>('AdminPanel/ApiCredentials', pmsCredential);
  }

  deleteSystemConfig(id: number): Observable<boolean> {
    return this.restApiService.delete<boolean>('AdminPanel/ApiCredentials/' + id);
  }

  updateSystemConfig(pmsCredential: PmsCredentialModel): Observable<boolean> {
    return this.restApiService.associate<boolean>('AdminPanel/ApiCredentials', pmsCredential);
  }

  buildiumTokenExchange(jwtToken: string): Observable<void> {
    return this.restApiService.associate<void>('AdminPanel/buildiumTokenExchange', { jwtToken });
  }
}
